import styled from "styled-components";
import { WhiteButton, WhiteButtonProps } from "components/shared/buttons";
import { ModalActionButtonStyles } from "./ModalActionButtonStyles";

export const ModalSecondaryActionButton = styled(WhiteButton)<WhiteButtonProps>`
  ${ModalActionButtonStyles};
`;
